export const manufacturer = {
    labels: {
        manufacturer: "Fabricante",
        manufacturers: "Fabricantes",
        edit_manufacturer: "Editar Fabricante",
    },
    placeholders: {
        name: "Informe o nome",
        description: "Informe a descrição",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_manufacturer: "Adicionar Fabricante",
            edit_manufacturer: "Editar Fabricante",
            del_manufacturer: "Excluir Fabricante",
        },
        messages: {
            del_manufacturer: "Você deseja mesmo excluir o fabricante <strong>{name}</strong>?<br/>Todos os relacionamentos deste fabricante serão excluídos.",
        },
    },
    texts: {
    },
};
